<template>
  <section class="elementor_section body mb-2 d-flex align-items-center">
    <div class="d-flex restos-sect">
      <div class="d-flex align-items-center position-relative">
        <div
          class="d-lg-block justify-content-start restos-text-area-1 position-absolute text-center text-md-start elementor_container"
        >
          <span class="restos-section__kicker">{{ $t("restaurants") }} &amp; {{ $t("bars") }}</span>
          <h2 class="restos-section__title">{{ $t("Flavors") }}</h2>
          <span
            class="d-block main-text lh-base w-75"
            data-aos="fade-up"
            data-aos-once="true"
            data-aos-duration="1500"
          >
            {{ generalStore().getVariable("front_restaurant") }}
          </span>
          <NuxtLink
            :to="redirect('flavors')"
            class="restos-section__btn"
          >
            {{ $t("view_all_restaurants") }}
          </NuxtLink>
        </div>
      </div>
      <div class="d-flex align-items-end justify-content-end restos-media" ref="mediaEl">
        <NuxtImg
          format="webp"
          class="restos_img d-none d-md-block"
          src="https://api2.salamisbayconti.com/storage/chineseewebb.webp"
          alt="chinese restaurant"
          loading="lazy"
          width="1920"
          height="1360"
        />
        <NuxtImg
          format="webp"
          class="restos_img d-md-none"
          src="https://api2.salamisbayconti.com/storage/chinese.webp"
          alt="chinese restaurant"
          loading="lazy"
          width="1920"
          height="1360"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return { zoomRaf: null };
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
  },
  methods: {
    redirect(route) {
      if (this.language === 'en') {
        return `/en/${route}`;
      }
      return `/${route}`;
    },
    // Image grows from 1x to 1.3x as the section travels through the viewport.
    updateZoom() {
      this.zoomRaf = null;
      const el = this.$refs.mediaEl;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      if (rect.bottom < 0 || rect.top > vh) return;
      const progress = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
      el.style.setProperty('--resto-zoom', (1 + progress * 0.3).toFixed(4));
    },
    onScroll() {
      if (!this.zoomRaf) this.zoomRaf = requestAnimationFrame(this.updateZoom);
    },
  },
  mounted() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.updateZoom();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    if (this.zoomRaf) cancelAnimationFrame(this.zoomRaf);
  },
};
</script>

<style scoped>
.elementor_section {
  background: #00141f;
  height: 65vh;
  min-height: 520px;
  max-height: 650px;
  position: relative;
}
.restos-sect {
  padding-inline: auto;
  width: 800vw;
  justify-content: space-between;
  margin-inline: auto;
  max-width: 1500px;
}
.restologo {
  position: absolute;
  top: clamp(24px, 3vw, 48px);
  right: clamp(20px, 4vw, 64px);
  z-index: 3;
  width: 200px;
  height: auto;
  aspect-ratio: 200 / 130;
  object-fit: contain;
}
.restos-text-area-1 {
  color: white;
  object-fit: cover;
  width: 50vw;
}
.restos-section__kicker {
  display: block;
  margin-bottom: 14px;
  font-family: 'Jost', sans-serif;
  font-size: .9375rem;
  font-weight: 400;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: #C19A45;
}
.restos-section__title {
  margin: 0 0 20px;
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: clamp(38px, 4.6vw, 62px);
  font-weight: 300;
  line-height: 1.18;
  color: #FBF9F6;
}

.restos_img {
  height: 100%;
  max-height: 600px;
  object-fit: cover;
  width: auto;
  scale: var(--resto-zoom, 1);
  will-change: scale;
  transition: scale 1200ms cubic-bezier(.2, .7, .2, 1);
}
.restos-media {
  overflow: hidden;
}

.main-text {
  font-family: 'Jost', sans-serif;
  font-size: clamp(17px, 1.35vw, 21px);
  font-weight: 300 !important;
  line-height: 1.75 !important;
}
.restos-section__btn {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  margin-top: 20px;
  padding: 14px 28px;
  border: 1px solid rgba(251, 249, 246, .6);
  color: #FBF9F6;
  font-family: 'Jost', sans-serif;
  font-size: .75rem;
  font-weight: 500;
  letter-spacing: .16em;
  text-transform: uppercase;
  text-decoration: none;
  transition: background 200ms ease, color 200ms ease, border-color 200ms ease;
}
.restos-section__btn:hover {
  background: #FBF9F6;
  color: #00141f;
  border-color: #FBF9F6;
}

@media (max-width: 768px) {
  .elementor_section {
    height: 560px;
    max-height: none;
    overflow: hidden;
  }
  .restos-sect {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: none;
    margin: 0;
    display: block !important;
  }
  .restos-sect > div:first-child {
    position: absolute !important;
    inset: 0;
    display: flex !important;
    align-items: center !important;
    justify-content: center;
    z-index: 2;
  }
  .restos-sect > div:last-child {
    position: absolute !important;
    inset: 0;
    z-index: 0;
  }
  .restologo {
    display: none;
  }
  .restos-text-area-1 {
    position: static !important;
    display: block !important;
    z-index: auto;
    color: white;
    background: transparent;
    width: 100%;
    height: auto;
    padding: 24px 20px;
    text-align: center !important;
  }
  .restos-section__kicker {
    margin-bottom: 10px;
    font-size: .6875rem;
    letter-spacing: .2em;
  }
  .restos-section__title {
    margin-bottom: 14px;
    font-size: clamp(2.25rem, 11vw, 3.25rem);
    line-height: 1.05;
  }
  .main-text {
    margin-inline: auto;
    font-size: .8125rem;
    line-height: 1.5 !important;
    font-weight: 300 !important;
    text-align: center;
  }
  .restos-section__btn {
    padding: 12px 22px;
    font-size: .6875rem;
    letter-spacing: .12em;
  }
  .restos_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(48%);
  }
}

@media (min-width: 769px) and (max-width: 1100px) {
  .restos-sect {
    margin-left: 5vw;
  }
  .main-text {
    font-size: clamp(17px, 1.35vw, 21px);
    text-align: start;
  }
}

@media (min-width: 1100px) and (max-width: 2200px) {
  .restos-text-area-1 {
    margin-left: 5vw;
  }
  .restos-sect {
    max-height: 820px;
    margin-inline: auto;
  }
}

@media (min-width: 2200px) {
  .restos-text-area-1 {
    margin-left: 12%;
  }
  .restos_img {
    max-height: 850px;
  }
  .restos-sect {
    max-width: 1950px;
  }
}
/* Mobile: +10px vertical padding (fixed-height section grows by the same 20px) */
@media (max-width: 767px) {
  .elementor_section { height: 580px; }
  .restos-text-area-1 { padding-block: 34px; }
}
</style>
